import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Container } from "react-bootstrap";
import { NavigationBar } from "./NavigationBar";

const ChatBotBody = ({ username, refreshCounter }) => {
    const chatbotAppId = process.env.REACT_APP_TOKEN;
    return(
        <HelmetProvider key={refreshCounter}>
            <Helmet script={
                [{type: "text/javascript", innerHTML: `xenioowebchat.EmbedChatLanding({ container: "chatexperience",  landingUrl: "https://mylinkconnect-res.mbdt01.com/landing/display.html?route=bXlsaW5rY29ubmVjdC1yb3V0aW5nLm1iZHQwMS5jb20*&bot_key=${chatbotAppId}&username=${username}&refreshCounter=${refreshCounter}" })`}]
            }  /> 

            <Container>
                <div id="chatexperience" style={{width: "100%", height: 600}}></div>
            </Container>
        </HelmetProvider>
    );
}

const Chatbot = ({ username }) => {
    const [refreshCounter, setRefreshCounter] = React.useState(0);
    
    const resetFn = () => {
        setRefreshCounter((prev) => (prev + 1));
    }
    return (
        <>
            <NavigationBar resetFn={resetFn} />
            <ChatBotBody username={username} refreshCounter={refreshCounter} />
        </>
        
    );
};

export default Chatbot;